export const MicIcon = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M10 1.25a2.5 2.5 0 0 0-2.5 2.5v5a2.5 2.5 0 0 0 5 0v-5a2.5 2.5 0 0 0-2.5-2.5Z" fill="currentColor"/>
  <path d="M5 8.75a.625.625 0 0 0-1.25 0A6.25 6.25 0 0 0 9.375 14.9v2.35H7.5a.625.625 0 1 0 0 1.25h5a.625.625 0 1 0 0-1.25h-1.875V14.9A6.25 6.25 0 0 0 16.25 8.75a.625.625 0 1 0-1.25 0 5 5 0 0 1-10 0Z" fill="currentColor"/>
</svg>`;

export const MicOffIcon = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M10 1.25a2.5 2.5 0 0 0-2.5 2.5v5a2.5 2.5 0 0 0 5 0v-5a2.5 2.5 0 0 0-2.5-2.5Z" fill="currentColor" opacity="0.4"/>
  <path d="M5 8.75a.625.625 0 0 0-1.25 0A6.25 6.25 0 0 0 9.375 14.9v2.35H7.5a.625.625 0 1 0 0 1.25h5a.625.625 0 1 0 0-1.25h-1.875V14.9A6.25 6.25 0 0 0 16.25 8.75a.625.625 0 1 0-1.25 0 5 5 0 0 1-10 0Z" fill="currentColor" opacity="0.4"/>
  <line x1="3" y1="17" x2="17" y2="3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
</svg>`;

export const SendIcon = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M14.354 1.646a.5.5 0 0 1 .12.542l-5 13a.5.5 0 0 1-.928.02L6.22 10.28a.5.5 0 0 0-.5-.5L.792 7.454a.5.5 0 0 1 .02-.928l13-5a.5.5 0 0 1 .542.12Z" fill="currentColor"/>
</svg>`;

export const ExpandIcon = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none">
  <path d="M3 11.25v3.75h3.75M15 6.75V3h-3.75M3 6.75V3h3.75M15 11.25v3.75h-3.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

export const ExitIcon = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M15 5 5 15M5 5l10 10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
</svg>`;

export const DragIcon = `<svg width="16" height="8" viewBox="0 0 16 8" fill="currentColor">
  <circle cx="2" cy="2" r="1.5"/>
  <circle cx="8" cy="2" r="1.5"/>
  <circle cx="14" cy="2" r="1.5"/>
  <circle cx="2" cy="6" r="1.5"/>
  <circle cx="8" cy="6" r="1.5"/>
  <circle cx="14" cy="6" r="1.5"/>
</svg>`;

export const PhoneEndIcon = `<svg width="28" height="28" viewBox="0 -3 20 20" fill="none">
  <path d="M1.667 8.333c0-1.666 3.333-5 8.333-5s8.333 3.334 8.333 5l-2.5 1.667-2.5-1.25v-1.667c-1.041-.416-2.291-.416-3.333-.416s-2.292 0-3.333.416v1.667l-2.5 1.25-2.5-1.667Z" fill="currentColor"/>
</svg>`;

export const FullscreenIcon = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"/>
</svg>`;

export const FullscreenExitIcon = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"/>
</svg>`;

export const PauseIcon = `<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
  <rect x="6" y="4" width="4" height="16" rx="1"/>
  <rect x="14" y="4" width="4" height="16" rx="1"/>
</svg>`;

export const PlayIcon = `<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
  <polygon points="5,3 19,12 5,21"/>
</svg>`;

export const SunIcon = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none">
  <circle cx="8" cy="8" r="3" stroke="currentColor" stroke-width="1.5"/>
  <path d="M8 1v2M8 13v2M1 8h2M13 8h2M3.05 3.05l1.41 1.41M11.54 11.54l1.41 1.41M3.05 12.95l1.41-1.41M11.54 4.46l1.41-1.41" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
</svg>`;

export const MoonIcon = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M13.6 9.8A6 6 0 0 1 6.2 2.4 6 6 0 1 0 13.6 9.8Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
